import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export class FixedNav {
  constructor() {
    this.DOM = {};
    this.DOM.nav = document.querySelectorAll('.js-nav');
    this.DOM.startSection = document.querySelector('.js-beforeStory');
    this.DOM.endSection = document.querySelector('.js-footer');
    this.DOM.navLine = document.querySelector('.js-navLine');
    this.DOM.navLineClose = document.querySelector('.js-navLineClose');

    if (!this.DOM.nav) return;

    this.onInit();
  }
  /**
   * 初期化
   */
  onInit() {
    this._setScrollTrigger();
    this._closeEvent();
  }
  /**
   * スクロールトリガーのセット
   */
  _closeEvent() {
    this.DOM.navLineClose.addEventListener('click',(e)=>{
      this.DOM.navLine.classList.add('is-hidden');
    });
  }
  /**
   * スクロールトリガーのセット
   */
  _setScrollTrigger() {

    this.DOM.nav.forEach(element => {
      // スクロールで表示
      gsap.to( element, {
        scrollTrigger: {
          trigger: this.DOM.startSection,
          start: 'top top', 
          fastScrollEnd: true,
          scrub: true,
          onEnter: ()=> {
            element.classList.add('is-visible');
          },
          onLeaveBack: ()=> {
            element.classList.remove('is-visible');
          },
        }
      });
      gsap.to( element, {
        scrollTrigger: {
          trigger: this.DOM.endSection,
          start: 'top bottom', 
          fastScrollEnd: true,
          scrub: true,
          onEnter: ()=> {
            element.classList.remove('is-visible');
          },
          onLeaveBack: ()=> {
            element.classList.add('is-visible');
          },
        }
      });
    
      
    });

  }
}
